import {
    DATIQ_DEFAULT_BOOLEAN,
    DATIQ_DEFAULT_ID,
    DATIQ_DEFAULT_STRING,
    datiqFormatNumber,
} from '@dat/datiq-core/models';
import { DateTime } from 'luxon';
import { DatiqPanelPopupPosition } from '../../../models';
import { emptyDatiqPanelPopup } from '../../datiq-panel-popup/models';
import { IDatiqPanelPopupForm } from './datiq-panel-popup-form.interface';

export const DATIQ_PANEL_POPUP_FROM_DEFAULT_ICON = 'app:arrow-drop-down';
export const DATIQ_PANEL_POPUP_FROM_DEFAULT_ICON_CLOSE = 'app:arrow-drop-up';

export const datiqPanelPopupFormChipLabelDate = (
    label: string,
    date: string | Date
): string => {
    const dateString = DateTime.fromJSDate(new Date(date)).toFormat('M/dd/yy');

    return `${label} ${dateString}`;
};
export const datiqPanelPopupFormChipLabelNumber = (
    pluralLabel: string,
    quantity: number,
    singleLabel?: string
): string => {
    const numberString: string = datiqFormatNumber(quantity);

    return quantity === 1
        ? `${numberString} ${singleLabel ?? pluralLabel}`
        : `${numberString} ${pluralLabel}`;
};

export const emptyDatiqPanelPopupForm: IDatiqPanelPopupForm = {
    id: DATIQ_DEFAULT_ID('panel-popup-form'),
    label: DATIQ_DEFAULT_STRING,
    isHighlighted: DATIQ_DEFAULT_BOOLEAN,
    panel: {
        ...emptyDatiqPanelPopup,
        icon: DATIQ_PANEL_POPUP_FROM_DEFAULT_ICON,
        closeIcon: DATIQ_PANEL_POPUP_FROM_DEFAULT_ICON_CLOSE,
        position: DatiqPanelPopupPosition.LeftBottom,
        closeOnEsc: true,
        closeOnOutsideClick: false,
    },
};
